import { useEffect } from 'react';

function useThemeColor(color: string): void {
  useEffect(() => {
    let metaTag = document.querySelector(
      'meta[name="theme-color"]'
    ) as HTMLMetaElement;

    if (!metaTag) {
      metaTag = document.createElement('meta');
      metaTag.name = 'theme-color';
      document.head.appendChild(metaTag);
    }

    metaTag.content = color;

    return () => {
      metaTag.content = '#ffffff';
    };
  }, [color]);
}

export default useThemeColor;
